<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Casos y Pólizas</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="2">
              <b-form-group label="Tipo de Fecha">
                <b-form-radio-group v-model="datosFormulario.selected" @input="cambiarFechas">
                  <b-form-radio   name="some-radios" value="A">Vigencia Póliza</b-form-radio>
                  <b-form-radio   name="some-radios" value="F">Por Fecha</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group :label="crearLabel('Fecha Desde', 'fdesde', 'datosFormulario')"
                          label-for="fdesde" :horizontal="false" v-show="mostrarFechas">
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fdesde"
                          :disabled="campoBloqueado('fdesde', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fdesde }}
                  </span>
                  </b-input-group>
              </b-form-group>    
                <b-form-group
                    :label="crearLabel('Origen Prórroga', 'origenpro', 'datosFormulario')"
                    label-for="origenpro">
                    <b-form-select 
                    :options="valOrigen"  
                    v-model="datosFormulario.origenpro"
                    :disabled="campoBloqueado('origenpro', 'datosFormulario')"
                    >
                    </b-form-select>
                    
                    <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.origenpro }}
                    </span>
                </b-form-group>
              
            </b-col>

            <b-col sm="3" v-show="mostrarFechas">  
              <b-form-group :label="crearLabel('Fecha Hasta', 'fhasta', 'datosFormulario')"
                          label-for="fhasta" :horizontal="false" >
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fhasta"
                          :disabled="campoBloqueado('fhasta', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fhasta }}
                  </span>
                  </b-input-group>
              </b-form-group>    

            </b-col>
            <b-col sm="4">  
                <b-form-group
                    :label="crearLabel('Pólizas', 'polizas', 'datosFormulario')"
                    label-for="polizas">
                    <multiselect 
                        v-model="value" 
                        tag-placeholder="Seleccionar póliza" 
                        placeholder="Buscar póliza" 
                        label="name" 
                        track-by="code" 
                        :options="valPolizas" 
                        :multiple="true" 
                        :taggable="true" 
                        @tag="addTag">
                    </multiselect>
                    <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.poliza }}
                    </span>
                </b-form-group>
           </b-col>  
             
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Casos y Pólizas</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Resumen de Casos</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters2[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data2"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filters2"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles2"
                  :prop="title.prop"
                  :min-width="title.minwidth"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "TareasActividades",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      data2: [],
      nombreexcel: "SiniestrosPorPóliza",
      //titlesDinamic: [],
      titles: [
        {
          prop: "Correlativo",
          label: "#",
          align: "right",
          minwidth:'70'
        },
        {
          prop: "Asegurado",
          label: "Asegurado",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "Póliza",
          label: "Póliza",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Producto",
          label: "Producto",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "N° Aviso/Siniestro",
          label: "N° Aviso o Siniestro",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Estado",
          label: "Estado",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "Origen",
          label: "Origen",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "Cliente",
          label: "Cliente",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "RUT Cliente",
          label: "RUT",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Tipo de Cliente",
          label: "Tipo",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Fecha Denuncio",
          label: "Denuncio",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Fecha 1er Impago",
          label: "1er Impago",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Monto Impago Inicial en MonPol",
          label: "Impago Inicial MonPol",
          align: "right",
          minwidth:'230'
        },
        {
          prop: "Moneda",
          label: "Moneda",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Monto Impago",
          label: "Impago",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Cobrador Vigente",
          label: "Cobrador Vigente",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Fecha Asig. Cobrador Inicial",
          label: "Asig. Cobranza",
          align: "left",
          minwidth:'230'
        },
        {
          prop: "Liquidador Asignado",
          label: "Liquidador",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Fecha Asig. Liquidador",
          label: "Asig. Liquidador",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Fecha Est. Config",
          label: "Est. Config",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Informe Liquidación Recibido",
          label: "Inf. Liq. Recibido",
          align: "left",
          minwidth:'230'
        },
        {
          prop: "Gestiones de Cobranza",
          label: "Gestiones Cobranza",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "Carta Castigo Env.",
          label: "Carta Castigo Env.",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Observaciones Asegurado",
          label: "Observaciones Asegurado",
          align: "left",
          minwidth:'500'
        },
        {
          prop: "Observaciones Internas",
          label: "Observaciones Internas",
          align: "left",
          minwidth:'500'
        },
        {
          prop: "Beneficiario",
          label: "Beneficiario",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "Fecha de Indemnización",
          label: "Fecha de Indemnización",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Monto Indemnizado en CLP",
          label: "Indemnizado en CLP",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Monto Indemnizado en MonPol",
          label: "Indemnizado en MonPol",
          align: "right",
          minwidth:'230'
        },
        {
          prop: "Devolución recuperos en CLP",
          label: "Devolución recuperos CLP",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Devolución recuperos en MonPol",
          label: "Devolución recuperos MonPol",
          align: "right",
          minwidth:'230'
        },
        {
          prop: "Excepción",
          label: "Excepción",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Coaseguro",
          label: "Coaseguro",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Parte Cubierta",
          label: "Parte Cubierta",
          align: "right",
          minwidth:'150'
        }
      ],
      filters: [
        {
          prop: ["Correlativo",
                "Asegurado",
                "Póliza",
                "Producto",
                "N° Aviso/Siniestro",
                "Estado",
                "Origen",
                "Cliente",
                "RUT Cliente",
                "Tipo de Cliente",
                "Fecha Denuncio",
                "Fecha 1er Impago",
                "Monto Impago Inicial en MonPol",
                "Moneda",
                "Monto Impago",
                "Cobrador Vigente",
                "Fecha Asig. Cobrador Inicial",
                "Liquidador Asignado",
                "Fecha Asig. Liquidador",
                "Fecha Est. Config",
                "Informe Liquidación Recibido",
                "Gestiones de Cobranza",
                "Carta Castigo Env.",
                "Observaciones Asegurado",
                "Observaciones Internas",
                "Beneficiario",
                "Fecha de Indemnización",
                "Monto Indemnizado en CLP",
                "Monto Indemnizado en MonPol",
                "Devolución recuperos en CLP",
                "Devolución recuperos en MonPol",
                "Excepción",
                "Coaseguro",
                "Parte Cubierta"
                 ],
          value: ""
        }
      ],

      titles2: [
        {
          prop: "Clasificación",
          label: "Clasificación",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "Número de Casos",
          label: "Número de Casos",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Activo",
          label: "Activo",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Cerrado",
          label: "Cerrado",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Desistido",
          label: "Desistido",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Indemnizado",
          label: "Indemnizado",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Plan de Pago",
          label: "Plan de Pago",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Rechazado",
          label: "Rechazado",
          align: "right",
          minwidth:'150'
        },
        /*
        {
          prop: "Anulado",
          label: "Anulado",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Apelado",
          label: "Apelado",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Doc. Incompletos",
          label: "Doc. Incompletos",
          align: "right",
          minwidth:'150'
        },*/
        {
          prop: "Indemnizaciones",
          label: "Indemnizaciones",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Devoluciones",
          label: "Devoluciones",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Inf. Liq. Pendiente",
          label: "Inf. Liq. Pendiente",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Casos Castigados",
          label: "Casos Castigados",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Casos Excepcionados",
          label: "Casos Excepcionados",
          align: "right",
          minwidth:'170'
        }
      ],
      filters2: [
        {
          prop: ["Clasificación",
                "Número de Casos",
                "Activo",
                "Cerrado",
                "Desistido",
                "Indemnizado",
                "Plan de Pago",
                "Rechazado",
                /*
                "Anulado",
                "Apelado",
                "Doc. Incompletos",*/
                "Indemnizaciones",
                "Devoluciones",
                "Inf. Liq. Pendiente",
                "Casos Castigados",
                "Casos Excepcionados"
                 ],
          value: ""
        }
      ],

      mostrarFechas: true,
      datosFormulario: {},
      valOrigen: [],
      valPolizas: [],
      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];
      this.value = null;

      return apiInformes
        .pre_insercion_siniporpoliza(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.origenpro = lista_data[i]["origenpro"];
              this.datosFormulario.selected = lista_data[i]["selected"];
              this.datosFormulario.fdesde = lista_data[i]["fdesde"];
              this.datosFormulario.fhasta = lista_data[i]["fhasta"];
          }
         
          if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
          }else{
            this.mostrarFechas = true;
          }
      
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de polizas
          var tiposPolizas = new Array();
          var lista_tipos_polizas = response.data.poliza;
          for(var i = 0; i < lista_tipos_polizas.length; i++){
              var obj = new Object();
              obj.name = lista_tipos_polizas[i]["poliza"];
              obj.code = lista_tipos_polizas[i]["poliza"];
              tiposPolizas.push(obj);
          }
          this.valPolizas = tiposPolizas;

          //Carga lista de origen
          var tiposOrigen = new Array();
          var lista_tipos_origen = response.data.origenpro;
          for(var i = 0; i < lista_tipos_origen.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_origen[i]["origenpro"];
              obj.text = lista_tipos_origen[i]["desc_origenpro"];
              tiposOrigen.push(obj);
          }
          this.valOrigen = tiposOrigen;
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      //Carga lista de polizas
      if (this.value != null && this.value != ""){
        var seleccionPolizas = "";
        for(var i = 0; i < this.value.length; i++){
          seleccionPolizas += "," + this.value[i]["code"];
        }
        seleccionPolizas = seleccionPolizas.substring(1,seleccionPolizas.length);
      }else{
        seleccionPolizas = "0";
      }
      

      return apiInformes
        .siniporpoliza(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          seleccionPolizas,
          this.datosFormulario.fdesde, 
          this.datosFormulario.fhasta, 
          this.datosFormulario.origenpro,
          this.datosFormulario.selected
        )
        .then(response => {
          this.data  = response.data.res1;
          this.data2  = response.data.res2;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
            
            for(var i = 0; i < response.data.res1.length; i++){
                this.data[i]["Correlativo"] = (i + 1);
            }
          } else {
            this.exportar = false;
          }

          
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      
      if ((column.property == "Fecha Denuncio" || 
           column.property == "Fecha 1er Impago" ||
           column.property == "Fecha Asig. Cobrador Inicial" ||
           column.property == "Fecha Est. Config" ||
           column.property == "Fecha Asig. Liquidador" ||
           column.property == "Fecha de Indemnización"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if ((column.property == "Monto Indemnizado en MonPol" ||
                column.property == "Monto Impago Inicial en MonPol" ||
                column.property == "Devolución recuperos en MonPol" ||
                column.property == "Coaseguro" ||
                column.property == "Parte Cubierta"
      ) && row[column.property]) {
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format('0,0.00');
        }
      }
      else if ((column.property == "Monto Impago" ||
                column.property == "Monto Indemnizado en CLP" ||
                column.property == "Devolución recuperos en CLP" ||
                column.property == "Número de Casos" ||
                column.property == "Activo" ||
                column.property == "Cerrado" ||
                column.property == "Desistido" ||
                column.property == "Indemnizado" ||
                column.property == "Plan de Pago" ||
                column.property == "Rechazado" ||
                /*
                column.property == "Anulado" ||
                column.property == "Apelado" ||
                column.property == "Doc. Incompletos" ||*/
                column.property == "Indemnizaciones" ||
                column.property == "Devoluciones" ||
                column.property == "Inf. Liq. Pendiente" ||
                column.property == "Casos Castigados" ||
                column.property == "Casos Excepcionados"
               ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format();
        }
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      //Carga lista de polizas
      if (this.value != null && this.value != ""){
        var seleccionPolizas = "";
        for(var i = 0; i < this.value.length; i++){
          seleccionPolizas += "," + this.value[i]["code"];
        }
        seleccionPolizas = seleccionPolizas.substring(1,seleccionPolizas.length);
      }else{
        seleccionPolizas = "Todas";
      }

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Siniestros por Póliza</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Polizas: "+seleccionPolizas+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      for (var key in this.data) {
          
          if(this.data[key]["Monto Impago Inicial en MonPol"] == undefined){
              this.data[key]["Monto Impago Inicial en MonPol"] = "";
          }
          if(this.data[key]["Cobrador Vigente"] == undefined){
              this.data[key]["Cobrador Vigente"] = "";
          }
          if(this.data[key]["Fecha Asig. Cobrador Inicial"] == undefined){
              this.data[key]["Fecha Asig. Cobrador Inicial"] = "";
          }
          if(this.data[key]["Liquidador Asignado"] == undefined){
              this.data[key]["Liquidador Asignado"] = "";
          }
          if(this.data[key]["Fecha Asig. Liquidador"] == undefined){
              this.data[key]["Fecha Asig. Liquidador"] = "";
          }
          if(this.data[key]["Fecha Est. Config"] == undefined){
              this.data[key]["Fecha Est. Config"] = "";
          }
          if(this.data[key]["Gestiones de Cobranza"] == undefined){
              this.data[key]["Gestiones de Cobranza"] = "";
          }
          if(this.data[key]["Observaciones Asegurado"] == undefined){
              this.data[key]["Observaciones Asegurado"] = "";
          }
          if(this.data[key]["Observaciones Internas"] == undefined){
              this.data[key]["Observaciones Internas"] = "";
          }
          if(this.data[key]["Beneficiario"] == undefined){
              this.data[key]["Beneficiario"] = "";
          }
          if(this.data[key]["Fecha de Indemnización"] == undefined){
              this.data[key]["Fecha de Indemnización"] = "";
          }
          if(this.data[key]["Monto Indemnizado en CLP"] == undefined){
              this.data[key]["Monto Indemnizado en CLP"] = "";
          }
          if(this.data[key]["Monto Indemnizado en MonPol"] == undefined){
              this.data[key]["Monto Indemnizado en MonPol"] = "";
          }
          if(this.data[key]["Devolución recuperos en CLP"] == undefined){
              this.data[key]["Devolución recuperos en CLP"] = "";
          }
          if(this.data[key]["Devolución recuperos en MonPol"] == undefined){
              this.data[key]["Devolución recuperos en MonPol"] = "";
          }
          if(this.data[key]["Coaseguro"] == undefined){
              this.data[key]["Coaseguro"] = "";
          }
          if(this.data[key]["RUT Cliente"] == undefined){
              this.data[key]["RUT Cliente"] = "";
          }
          if(this.data[key]["Origen"] == undefined){
              this.data[key]["Origen"] = "";
          }

          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Correlativo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Asegurado"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Póliza"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Producto"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["N° Aviso/Siniestro"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Estado"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Origen"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Cliente"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["RUT Cliente"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Tipo de Cliente"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Denuncio"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha 1er Impago"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Monto Impago Inicial en MonPol"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Moneda"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Monto Impago"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Cobrador Vigente"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Asig. Cobrador Inicial"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Liquidador Asignado"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Asig. Liquidador"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Est. Config"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Informe Liquidación Recibido"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Gestiones de Cobranza"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Carta Castigo Env."]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Observaciones Asegurado"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Observaciones Internas"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Beneficiario"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha de Indemnización"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Monto Indemnizado en CLP"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Monto Indemnizado en MonPol"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Devolución recuperos en CLP"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Devolución recuperos en MonPol"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Excepción"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Coaseguro"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Parte Cubierta"]).format('0,0.00')+"</td>\n";
          cuerpo += "</tr>\n";
      }


      cuerpo += "\n\n\n";
      
      var columnas = this.titles2;

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Resumen de Casos</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";
      
      //Data bloque 2
      for (var key in this.data2) {
          
          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Clasificación"]+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Número de Casos"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Activo"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Cerrado"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Desistido"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Indemnizado"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Plan de Pago"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Rechazado"]).format('0,0')+"</td>\n";
            /*
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Anulado"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Apelado"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Doc. Incompletos"]).format('0,0')+"</td>\n";*/
            
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Indemnizaciones"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Devoluciones"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Inf. Liq. Pendiente"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Casos Castigados"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 align=right style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Casos Excepcionados"]).format('0,0')+"</td>\n";
          cuerpo += "</tr>\n";
      }

      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}
</style>
